import { render, staticRenderFns } from "./psychologicalCounseling.vue?vue&type=template&id=68907ba1&scoped=true&"
import script from "./psychologicalCounseling.vue?vue&type=script&lang=js&"
export * from "./psychologicalCounseling.vue?vue&type=script&lang=js&"
import style0 from "./psychologicalCounseling.vue?vue&type=style&index=0&id=68907ba1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68907ba1",
  null
  
)

export default component.exports